import { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import MapLegend from './WF_MapLegend';
import Button from '../button/Button';

type MapLegendOverlayProps = {
  onClose: MouseEventHandler;
};

function MapLegendOverlay({ onClose }: MapLegendOverlayProps) {
  const { t } = useTranslation();

  return (
    <div
      className="absolute inset-0 z-[1001] flex items-center justify-center bg-black/50"
      onClick={() => onClose}
    >
      <div className="rounded bg-white p-2 text-center shadow-lg">
        <h2 className="mb-2 font-bold">{t('wf.sites.map.legend')}</h2>
        <MapLegend />
        <Button
          className="mt-2 w-full"
          title={t('wf.common.close')}
          onClick={(event) => {
            onClose(event);
          }}
        />
      </div>
    </div>
  );
}

export default MapLegendOverlay;
